import firebase from "firebase";
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyDHp7lwxRQH3Vel6E2N_RPPsWKJNEOiXeE",
  authDomain: "sites-agis.firebaseapp.com",
  databaseURL: "https://sites-agis.firebaseio.com",
  projectId: "sites-agis",
  storageBucket: "sites-agis.appspot.com",
  messagingSenderId: "479786027426",
  appId: "1:479786027426:web:c37786521dde8b363c4afb",
  measurementId: "G-1L54H864RJ"
};

firebase.initializeApp(firebaseConfig);

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const storageRef = storage.ref();
const auth = firebase.auth();

// firebase collections
// const categories = db.collection('categories');

export {
  firebase,
  db,
  storage,
  storageRef,
  auth
  // categories
}
